import { render } from "./partnership-type.vue?vue&type=template&id=18e0a8c6&ts=true"
import script from "./partnership-type.ts?vue&type=script&lang=ts&external"
export * from "./partnership-type.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__